import { jsx } from "react/jsx-runtime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { validateTidalLicense } from "../../base/index.js";
function ArrowBack(props) {
  return /* @__PURE__ */ jsx(
    ArrowBackIcon,
    {
      "data-testid": "ArrowBack",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ArrowBack",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ArrowBack.tidalIconMeta = {
  categories: "arrows",
  name: "ArrowBack"
};
validateTidalLicense();
export {
  ArrowBack
};
//# sourceMappingURL=ArrowBack.js.map
